export default {
  lucky: {
    prizeAgain: 'Gira Otra Vez',
    prizeThanks: 'Mejor Suerte la Próxima',
    remainingChance: 'Giros Restantes',
    task: 'Tarea',
    deposit: 'Depósito',
    wager: 'Apuesta',
    noChance: 'No spins available',
    drawFailed: 'Draw failed, please try again',
    prizeWin: 'Congratulations! You won {amount}',
    prizeAgainMsg: 'You got a free spin!',
  },
  card: {
    title: 'Colección de Cartas',
    puzzleRound: 'Ronda {current}/{total}',
    puzzleReward: 'Recompensa por completar {amount}',
    redeem: 'Canjear',
    redeemSuccess: 'Canjeado con éxito',
    redeemSuccessWithReward: '¡Canjeado con éxito! Has recibido {amount} {currency}',
    redeemFailed: 'Error al canjear',
    notComplete: 'Aún no está completo, no se puede canjear',
    drawFailed: 'Error en el sorteo, inténtalo de nuevo',
    gainLetter: '¡Felicidades! Has obtenido la letra {letter}',
    gainBlock: '¡Felicidades! Has obtenido la imagen {blockNo}',
    letterReward: '{redeemed}/{limit} · reward {amount}',
  },
  treasureChest: {
    invite: 'Invitar',
    claimReward: 'Reclamar',
    noChest: 'Sin cofre',
    claimSuccess: 'Reclamados {count} cofres, {amount} {currency}',
    modalTitle: 'Cofre del tesoro',
    modalSubtitle: 'Desliza para ver todos',
    chipTodayClaimed: 'Reclamado hoy',
    chipClaimable: 'Reclamable',
    chipLocked: 'Bloqueado',
    totalClaimedCount: 'Total de cofres reclamados',
    totalClaimedAmount: 'Monto total reclamado',
    chestUnit: 'uds',
    claimAll: 'Reclamar todo',
    goInvite: 'Ir a invitar',
    claimSingleSuccess: 'Reclamado {amount} {currency}',
    labelClaimed: 'Reclamado',
    labelClaimable: 'Reclamable',
    labelLocked: 'Bloqueado',
  },
}
